import * as React from 'react';
import MyMarker from '../../components/Marker';
import { ObjectCard } from '../../components/ObjectCard';
import { Box, Typography, Chip, Stack, Divider } from '@mui/material';
import { titleCase } from 'title-case';

const endpoint = "ctabuses";

const showCardContent = (obj) => { return true }

const ModuleMarker = (props) => {
    
    return (
        <MyMarker {...props} icondef={getIcon(props)} />
    )
}

const getIcon = (props) => {
    const obj = props.icon;
    var rotation = 0;
    if(obj.rotation){
        rotation = obj.rotation;
    }
    var iconname = "Bus_";
    if (rotation) {
        if (rotation > 45 && rotation <= 135) {
            iconname += "East.png";
        } else if (rotation > 135 && rotation <= 225) {
            iconname += "South.png";
        } else if (rotation > 225 && rotation <= 315) {
            iconname += "West.png";
        } else if (rotation > 315 || rotation <= 45) {
            iconname += "North.png";
        }
    } else {
        iconname += "East.png";
    }
    iconname = "/mapicons/bus/" + iconname;
    return {
        url: iconname,
        anchor: new window.google.maps.Point(6, 15),
        scaledSize: new window.google.maps.Size(30, 30)
    };
}

const getHeadingDirection = (rotation) => {
    if (!rotation && rotation !== 0) return null;
    
    if (rotation > 337.5 || rotation <= 22.5) {
        return "North";
    } else if (rotation > 22.5 && rotation <= 67.5) {
        return "Northeast";
    } else if (rotation > 67.5 && rotation <= 112.5) {
        return "East";
    } else if (rotation > 112.5 && rotation <= 157.5) {
        return "Southeast";
    } else if (rotation > 157.5 && rotation <= 202.5) {
        return "South";
    } else if (rotation > 202.5 && rotation <= 247.5) {
        return "Southwest";
    } else if (rotation > 247.5 && rotation <= 292.5) {
        return "West";
    } else if (rotation > 292.5 && rotation <= 337.5) {
        return "Northwest";
    }
    return null;
}

const CardContent = (props) => {
    const obj = props.obj;
    return (
        <Stack spacing={1.5} sx={{ minWidth: 200 }}>
            <Location value={obj} />
            <Stack spacing={1}>
                <Heading value={obj} />
                <Speed value={obj} />
                <VehicleId value={obj} />
            </Stack>
            <Divider />
            <LastUpdate value={obj} />
        </Stack>
    )
}

const Speed = props => {
    const obj = props.value;
    if(obj.busSpeed) {
        return (
            <Typography variant="body2">
                • {obj.busSpeed} MPH
            </Typography>
        )
    }
    return null;
}

const VehicleId = props => {
    const obj = props.value;
    if(obj.vehId) {
        return (
            <Typography variant="body2">
                • Vehicle ID: {obj.vehId}
            </Typography>
        )
    }
    return null;
}

const LastUpdate = props => {
    const obj = props.value;
    if(obj.lastUpdate){
        return (
            <Typography variant="caption">
                Updated: {obj.lastUpdate}
            </Typography>
        )
    }
    return null;
}

const Location = props => {
    const obj = props.value;
    if(obj.routeNum) {
        return (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <img src="/mapicons/bus/Bus_East.png" alt="Bus" style={{ width: 24, height: 24 }} />
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    Bus Route {obj.routeNum}
                </Typography>
            </Box>
        )
    }
    return null;
}

const Heading = props => {
    const obj = props.value;
    const direction = getHeadingDirection(obj.rotation);
    if(direction) {
        return (
            <Typography variant="body2">
                • Heading {direction}
            </Typography>
        )
    }
    return null;
}

const InfoWindow = (props) => {
    const module = props.module;
    const obj = props.icon;
    const MyCardContent = module.cardContent;
    const showCardContent = module.showCardContent;

    return (
        <Box className="map-popup-text" sx={{ 
            maxWidth: 300,
            '& .infoWindow': { border: 'none' }
        }}>
            {showCardContent(obj) ? <MyCardContent obj={obj} /> : null}
        </Box>
    )
}

export default {
    name: 'Buses',
    label: 'Bus Route #',
    marker: ModuleMarker,
    showOnMap: true, //show on map layer filter
    mapLayerIcon: "/mapicons/bus/Bus_East.png",
    showOnSidebar: false,
    sideBarCard: ObjectCard,
    endpoint: endpoint,
    defaultOn: false,
    updateDelay: 0,
    showCardContent: showCardContent,
    cardContent: CardContent,
    infoWindow: InfoWindow,
    cluster: false,
   // clusterMarker: "/mapicons/bus/Bus_East.png",
   // clusterClass: "signal-cluster",
    publishLayer: "tasWebapp.buses.enable"
}